var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionAdjustment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0217 18L7.35447 29.6673C6.76868 30.253 6.76868 31.2028 7.35447 31.7886V31.7886C7.94025 32.3744 8.89 32.3744 9.47579 31.7886L21.143 20.1213",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4862 21.5355L17.6075 23.6568",
    stroke: "#20242E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82935 27.1924L11.9507 29.3137",
    stroke: "#20242E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3289 17.4114L33.0419 16.9657C33.4332 16.9287 33.6308 16.4756 33.3917 16.1637L30.5119 12.4063C30.3988 12.2544 30.3243 12.0874 30.2885 11.9052C30.2526 11.723 30.2561 11.5388 30.2989 11.3525L31.3486 6.76575C31.4364 6.38232 31.0674 6.05239 30.6961 6.18224L26.2443 7.73918C26.0635 7.80125 25.8806 7.82398 25.6957 7.80738C25.5108 7.79077 25.3369 7.73415 25.1741 7.63751L21.142 5.20178C20.8055 4.99845 20.3767 5.24529 20.3836 5.63845L20.4659 10.3691C20.4756 10.5526 20.4455 10.7317 20.3758 10.9062C20.306 11.0808 20.1952 11.2247 20.0434 11.3378L16.4952 14.4393C16.2003 14.6971 16.3029 15.1786 16.6774 15.2937L21.1911 16.6811C21.3775 16.7239 21.5396 16.8075 21.6776 16.9317C21.8156 17.0559 21.9156 17.2085 21.9776 17.3893L23.8275 21.7291C23.9815 22.0903 24.4727 22.1412 24.6975 21.8192L27.4096 17.9329C27.5062 17.77 27.6377 17.6448 27.804 17.5572C27.9704 17.4696 28.1453 17.421 28.3289 17.4114Z",
    fill: "#0E5CF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionAdjustment);
export default __webpack_public_path__ + "static/media/ic-transaction-adjustment.a314424d0e3806b5940484d40b89f1ec.svg";
export { ForwardRef as ReactComponent };